import { render, staticRenderFns } from "./WarningDetail.vue?vue&type=template&id=58f9dafa&scoped=true"
import script from "./WarningDetail.vue?vue&type=script&lang=js"
export * from "./WarningDetail.vue?vue&type=script&lang=js"
import style0 from "./WarningDetail.vue?vue&type=style&index=0&id=58f9dafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f9dafa",
  null
  
)

export default component.exports